<template>
  <div>
    <v-menu :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <span
          class="d-inline-flex align-center filter-title"
          :class="{ 'font-weight-bold': isFilterApplied }"
          v-on="on"
          v-bind="attrs"
        >
          <v-icon left>
            date_range
          </v-icon>
          Created
          <v-icon>
            expand_more
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-text class="black--text">
          <div>
            <v-icon class="mr-1 black--text">date_range</v-icon>
            Post Created Date
          </div>

          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-text-field
                type="date"
                v-model="form.from"
                label="Pick the date from"
                dense
                outlined
                @input="submitForm"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                type="date"
                v-model="form.to"
                label="Pick the date to"
                dense
                outlined
                @input="submitForm"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: "FilterCreated",

  props: {
    moduleId: {
      type: [Symbol, String, Number],
      required: true
    }
  },

  data: () => ({
    form: {
      from: "",
      to: ""
    }
  }),

  computed: {
    // use the inputs to generate some text value
    textValue() {
      return `Created: from ${this.form.from} to ${this.form.to}`
    },

    isFilterApplied() {
      return Boolean(this.$store.getters["paidCollaborations/findFilterByType"](this.moduleId, "created"))
    }
  },

  validations: {
    form: {
      from: {
        required
      },
      to: {
        required
      }
    }
  },

  methods: {
    async submitForm() {
      await this.$v.$touch()

      if (this.$v.$anyError) return

      this.$store.dispatch("paidCollaborations/replaceFilter", {
        id: this.moduleId,
        sort: 1,
        type: "created",
        preventDelete: true,
        data: {
          color: "green lighten-4",
          icon: "date_range",
          iconColor: "green",
          text: this.textValue,
          inputs: {
            ...this.form
          }
        }
      })
    }
  },

  mounted() {
    // set default value for it
    this.form.from = dayjs().subtract(3, "day").format("YYYY-MM-DD")
    this.form.to = dayjs().format("YYYY-MM-DD")
    this.submitForm()
  }
}
</script>

<style lang="stylus">
// .filter-title
//   border-bottom 1px solid blue
//   padding-bottom 4px
</style>
